export const aplicarMarcaBody = (marcaNombre) => {
  if (!marcaNombre) {
    document.body.removeAttribute('data-marca');
    return;
  }

  const marcaNormalizada = marcaNombre.toUpperCase().trim();
  document.body.setAttribute('data-marca', marcaNormalizada);
};

